<div class="grid-x align-middle studyDetail" *ngIf="study">
    <div class="cell shrink studyDetail-arrow" (click)="selectPreviousStudy()">
        <i class="fas fa-angle-left"></i>
    </div>

    <div class="cell shrink studyDetail-document">
        <h2 class="studyDetail-document-title">{{'studies.' + study.studyId | translate}}</h2>
        <div class="studyDetail-document-price">{{study.price | number:'1.2'}} <span [i18nKey]="'common.change.euros'"></span></div>
    </div>

    <div class="cell auto studyDetail-infos">
        <h3 class="studyDetail-infos-title">
            <span [i18nKey]="'study.title.document'"></span>
            <span>{{'studies.' + study.studyId | translate}}</span>
            <span [i18nKey]="'study.title.availability'"></span></h3>

        <div class="studyDetail-infos-item" *ngIf="study.monthly">
            <span [i18nKey]="'studies.monthly.study'"></span>
            <div class="documentBtns">
                <button *ngIf="!study.cumulative" capture-id="access-monthly-study" class="button _tiny _iconLeft" [routerLink]="study.studyId" [disabled]="!study.available"><i class="fas fa-eye"></i> <span [i18nKey]="'common.monthly'"></span></button>
                <button *ngIf="study.cumulative" capture-id="access-monthly-study" class="button _tiny _iconLeft" [routerLink]="study.studyId + '/monthly'" [disabled]="!study.available"><i class="fas fa-eye"></i> <span [i18nKey]="'common.monthly'"></span></button>
            </div>
        </div>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <div class="studyDetail-infos-item" *ngIf="study.cumulative">
            <span [i18nKey]="'studies.cumulative.study'"></span>
            <div class="documentBtns">
                <button class="button _tiny _iconLeft" [routerLink]="study.studyId + '/cumulative'" [disabled]="!study.available"><i class="fas fa-eye"></i> <span [i18nKey]="'common.cumulative'"></span></button>
            </div>
        </div>

        <kiwi-spacer [size]="16"></kiwi-spacer>

        <div class="studyDetail-infos-item" *ngIf="!study.available">
            <div class="documentBtns">
                <button class="button _tiny _iconLeft" [routerLink]="study.studyId"><i class="far fa-file-alt"></i> <span [i18nKey]="'study.specimen'"></span></button>
                <button class="button _tiny _iconLeft" (click)="purchaseStudy(study)"><i class="fas fa-euro-sign"></i> <span [i18nKey]="'study.purchase'"></span></button>
            </div>
        </div>
    </div>

    <div class="cell shrink studyDetail-arrow" (click)="selectNextStudy()">
        <i class="fas fa-angle-right"></i>
    </div>
</div>
